<template>
  <div class="pa-2">
    <v-form ref="put_report_form">
      <v-textarea
        v-model="stateOfChild"
        :rules="[rules.counter500]"
        :readonly="!isDraft"
        auto-grow
        outlined
        dense />
      <div v-if="isDraft" class="d-flex justify-space-between">
        <v-btn
          @click="clickPost({ isDraft: true })"
          class="flex"
          color="primary"
          :loading="draftLoading"
          outlined>
          下書き保存
        </v-btn>
        <v-btn
          @click="clickPost({ isDraft: false })"
          class="flex ml-2"
          color="primary"
          :loading="sendLoading"
          depressed
          >送信</v-btn
        >
      </div>
    </v-form>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

import { dailyReportModule } from '@/store/entityModules/dailyReport';

import { VForm } from '@/model/Vuetify/VForm';

interface DataType {
  stateOfChild: string;
  draftLoading: boolean;
  sendLoading: boolean;
}

export default defineComponent({
  name: 'StateOfChildForm',

  props: {
    isDraft: {
      type: Boolean,
      default: true,
    },
    body: {
      type: String,
      default: '',
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).put_report_form;
    },
  },

  watch: {
    body: {
      handler(val: string) {
        if (val) {
          this.stateOfChild = this.body;
        }
      },
      deep: true,
    },
  },

  data: (): DataType => ({
    stateOfChild: '',
    draftLoading: false,
    sendLoading: false,
  }),

  methods: {
    async clickPost({ isDraft }: { isDraft: boolean }) {
      if (this.form.validate() && this.stateOfChild) {
        if (isDraft) {
          this.draftLoading = true;
        } else {
          this.sendLoading = true;
        }
        try {
          await dailyReportModule.putReport({
            childId: this.childId,
            date: this.selectedDate,
            stateOfChild: {
              isDraft: isDraft,
              body: this.stateOfChild,
            },
          });
          this.$emit('posted');
          this.draftLoading = false;
          this.sendLoading = false;
        } catch (error) {
          this.draftLoading = false;
          this.sendLoading = false;
        }
      }
    },
  },

  mounted() {
    this.stateOfChild = this.body;
  },
});
</script>
